export default __webpack_public_path__ + "static/NC_Charlotte-Regional-VA_1123_Merchant-Trade-60169-abacf06ce88dc5ae887c976a1caba173.jpg";